<ng-container *ngIf="activeTab === ACTIVE_TAB.TEAMS_OR_PLAYERS; else defaultHeader">
  <div class="teams-players-header container">
    <button type="button"
            class="teams-players-header__logo"
            (click)="openHomePage('')"
            aria-label="Go to giPant home">
      <img ngSrc="../../../assets/images/logos/gipant-logo.svg" width="98" height="55" priority alt="giPant">
    </button>

    <div class="teams-players-header__profile" 
         *ngIf="activeProfile; else burgerBtn"
         (click)="!activeProfile ? toggleNavBar() : ''">
      <div class="profile-info">
        <div class="club-team">
          <ng-container *ngIf="activeProfile.type === 'player'">
            {{ activeProfile?.club?.name ? activeProfile.club.name + ' ' : '' }}{{ activeProfile?.team?.name }}
          </ng-container>
          <ng-container *ngIf="activeProfile.type === 'team'">
            {{ activeProfile.club?.name ? activeProfile.club.name + ' ' : '' }}
          </ng-container>
        </div>
        <div class="player-full-name">
          <ng-container *ngIf="activeProfile.type === 'player'">
          {{ activeProfile.first_name }} {{ activeProfile.last_name }}
          </ng-container> 
          <ng-container *ngIf="activeProfile.type === 'team'">
            {{ activeProfile.name }}
          </ng-container>
        </div>
      </div>
      <div class="profile-avatar">
        <img [src]="(activeProfile.type === 'player' ? activeProfile.team?.avatar : activeProfile.avatar) || '../../../assets/images/icons/player.png'"
             alt="avatar">
      </div>
    </div>

    <ng-template #burgerBtn>
      <button type="button"
              class="teams-players-header__burger"
              (click)="toggleNavBar()"
              aria-label="Open navigation">
        <i class="icon icon-burger"></i>
      </button>
    </ng-template>
  </div>
</ng-container>

<ng-template #defaultHeader>
  <div class="container">
    <div class="row">
      <div class="col-12">
      <div class="header-wrap">
        <div class="nav-item link gipant-item"
             (click)="openHomePage('')"
             [ngClass]="{'active': activeTab === ACTIVE_TAB.GIPANT || activeTab === ACTIVE_TAB.TEAMS_OR_PLAYERS}">
          <span class="beta-ribbon">{{'HEADER.BETA' | translate}}</span>
          <div class="logo gipant-logo">
            <img ngSrc="../../../assets/images/logos/gipant-logo.svg" width="98" height="55" priority alt="giPant">
          </div>
          <div class="logo-text">{{'HEADER.GIPANT.TITLE' | translate}}</div>
          <div class="button">{{'HEADER.BUTTON' | translate}} <i class="icon icon-arrow-right"></i></div>
        </div>
        <div class="nav-item link henterpant-item"
             (click)="openHomePage('henter-pant')"
             [ngClass]="{'active': activeTab === ACTIVE_TAB.HENTERPANT}">
          <span class="beta-ribbon">{{'HEADER.BETA' | translate}}</span>
          <div class="logo henterpant-logo">
            <img ngSrc="../../../assets/images/logos/henterpant-logo.svg" width="152" height="55" priority alt="henterPant">
          </div>
          <div class="logo-text">{{'HEADER.HENTERPANT.TITLE' | translate}}</div>
          <div class="button">{{'HEADER.BUTTON' | translate}} <i class="icon icon-arrow-right"></i></div>
        </div>
        <div class="nav-item menu-burger" (click)="toggleNavBar()">
          <i class="icon icon-burger"></i>
        </div>
      </div>
      </div>
    </div>
  </div>
</ng-template>

<section class="main-navigation" [ngClass]="{'active': showNavBar}">
  <div class="buttons-wrap" *ngIf="activeTab === ACTIVE_TAB.HENTERPANT && !userData">
    <button class="btn btn-primary-henterpant" (click)="openSignInSignUp('sign-in')">{{'HEADER.SIGN_IN' | translate}}</button>
    <button class="btn btn-primary-henterpant sec" (click)="openSignInSignUp('sign-up')">{{'HEADER.SIGN_UP' | translate}}</button>
  </div>

  <div class="profile-header" *ngIf="activeTab === ACTIVE_TAB.HENTERPANT && userData">
    <div class="profile-info-wrap" (click)="openProfile();">
      <div class="profile-img" [style.background-image]="userData.profile.avatar ? 'url(' + userData.profile?.avatar + ')' : ''">
        <span class="icon icon-highlight"></span>
      </div>
      <div class="team-info">
        <h3>{{userData.profile?.name}}</h3>
        <p>{{userData.profile?.league}} {{userData.profile?.gender}} {{userData.profile?.club?.name}}</p>
      </div>
    </div>
    <button class="btn btn-secondary with-icon" (click)="logout(); $event.stopPropagation()">
      {{'HEADER.LOG_OUT' | translate}} <span class="icon icon-logout"></span>
    </button>
  </div>
  <div class="close-wrap" (click)="toggleNavBar()">
    <i class="icon icon-close"></i>
  </div>
<!--  <nav>-->
<!--    <ul>-->
<!--      <li *ngFor="let navItem of mainNavigation[activeTab]"-->
<!--          [class.active]="activeRoute && activeRoute === navItem.route || (navItem.anchor && activeAnchor === navItem.anchor)">-->
<!--        <a (click)="navItem.route ? goToPage(navItem.route) : navItem.anchor ? scrollToAnchor(navItem.anchor) : ''">{{navItem.title}}</a>-->
<!--      </li>-->
<!--      <li class="lang-switcher">-->
<!--        <p (click)="setLanguage(LANGS.EN)" [ngClass]="{'active': currentLanguage === LANGS.EN}">EN</p>-->
<!--        <p (click)="setLanguage(LANGS.NO)" [ngClass]="{'active': currentLanguage === LANGS.NO}">NO</p>-->
<!--      </li>-->
<!--    </ul>-->
<!--  </nav>-->

  <nav>
    <ul>
      <li *ngFor="let navItem of mainNavigation[activeTab]"
          [class.active]="activeRoute && activeRoute === navItem.route || (navItem.anchor && activeAnchor === navItem.anchor)">

        <!-- Parent link -->
        <div class="nav-parent">
          <a class="nav-link"
             (click)="handleClick(navItem)">
            <span class="nav-title">{{ navItem.title }}</span>
            <svg *ngIf="navItem.download" width="15" height="16" viewBox="0 0 15 16" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.75 11.5833V13.25C0.75 13.692 0.925595 14.116 1.23816 14.4285C1.55072 14.7411 1.97464 14.9167 2.41667 14.9167H12.4167C12.8587 14.9167 13.2826 14.7411 13.5952 14.4285C13.9077 14.116 14.0833 13.692 14.0833 13.25V11.5833M3.25 6.58333L7.41667 10.75M7.41667 10.75L11.5833 6.58333M7.41667 10.75V0.75" stroke="#AEB3BA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>  
            <span *ngIf="navItem.childrens?.length"
                  class="arrow" [class.open]="expandedItems.has(navItem.title)">
              <i class="icon icon-chevron-right"></i>
            </span>
          </a>
        </div>
        <!-- Child list -->
        <ul *ngIf="navItem.childrens?.length && expandedItems.has(navItem.title)" class="child-menu">
          <li *ngFor="let child of navItem.childrens"
              [class.active]="activeRoute && activeRoute === child.route || (child.anchor && activeAnchor === child.anchor)">
            <a class="nav-link"
               (click)="child.route ? handleClick(child, $event) : child.anchor ? scrollToAnchor(child.anchor, false) : ''">
              <span class="nav-title">{{ child.title }}</span>

              <svg *ngIf="child.download" width="15" height="16" viewBox="0 0 15 16" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.75 11.5833V13.25C0.75 13.692 0.925595 14.116 1.23816 14.4285C1.55072 14.7411 1.97464 14.9167 2.41667 14.9167H12.4167C12.8587 14.9167 13.2826 14.7411 13.5952 14.4285C13.9077 14.116 14.0833 13.692 14.0833 13.25V11.5833M3.25 6.58333L7.41667 10.75M7.41667 10.75L11.5833 6.58333M7.41667 10.75V0.75" stroke="#AEB3BA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </a>
          </li>
        </ul>
      </li>

      <!-- Lang switcher -->
      <li class="lang-switcher">
        <p (click)="setLanguage(LANGS.EN)" [ngClass]="{'active': currentLanguage === LANGS.EN}">EN</p>
        <p (click)="setLanguage(LANGS.NO)" [ngClass]="{'active': currentLanguage === LANGS.NO}">NO</p>
      </li>
    </ul>
  </nav>


  <div class="store-buttons-wrap">
    <a [href]="appleStoreLink" class="store-btn apple" target="_blank"></a>
    <a [href]="googlePlayLink" class="store-btn android" target="_blank"></a>
  </div>
</section>
